define([
  /* eslint-disable */
  'js/aofl-js/0.8.0/app/app',
  'readingiq-src/js/riq-js/riq-listener-set-previous-state-route/1.0.0/js/state-service/js/mutations-service/index-impl'
  /* eslint-enable */
], function RiqListenerRouteChangeMutationsService(
  app,
  riqListenerSetPreviousStateRouteMutationsImpl
) {
  'use strict';

  app.registerFactory('riqListenerSetPreviousStateRouteMutationsService', [
    riqListenerSetPreviousStateRouteMutationsImpl
  ]);
});
